import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const BookList = () => {
  useEffect(() => {
    document.title =
      "School Uniform & Book List -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics </li>
          <li>School Uniform & Book List</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> School Uniform & Book List </h1>
            </div>
          </div>
          <div className="row schoolinfo">
            <h6>Book List</h6>
            <div className="col-lg-6">
              <div className="linktab">
                <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/wel-2.pdf">
                  {" "}
                NOTICE - WELFARE CENTRE (BOOK SHOP){" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/wel-1.pdf">
                  {" "}
                  NOTICE - WELFARE CENTRE (UNIFORM SHOP){" "}
                </Link>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="linktab">
                <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/vender.pdf">
                  {" "}
                  LIST OF VENDORS / SHOPS IN THE CLOSE PROXIMITY OF SCHOOL WHERE
                  THE BOOKS/WRITING MATERIALS AND UNIFORMS ARE AVAILABLE{" "}
                </Link>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="linktab">
                <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NCERTTEXTBOOKS-26.pdf">
                  {" "}
                  AVAILABILITY OF NCERT TEXTBOOKS FOR CLASS IX (2026
                  EDITION){" "}
                </Link>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/BooksList26-27.pdf"
                  target="_blank"
                >
                  {" "}
                  CLASS-WISE LIST OF BOOKS 2026-27{" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NCERTBooks26-27.pdf"
                  target="_blank"
                >
                  {" "}
                  AVAILABILITY OF NCERT TEXTBOOKS 2026-27{" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Stationary26-27.pdf"
                  target="_blank"
                >
                  {" "}
                  NOTEBOOKS AND STATIONERY LIST 2026-27{" "}
                </Link>
              </div>
            </div>
            <div className="w-100"></div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/AdditionalBooksList.pdf"
                  target="_blank"
                >
                  {" "}
                  Text Books Additional for AF SCHOOLS - 2025-26{" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/BookList.pdf"
                  target="_blank"
                >
                  {" "}
                  Book List 2025-2026{" "}
                </Link>
              </div>
            </div>
            <p>
              As per the circular no. DE.15(305)/PSB/2020/Pt.File-III/4399-4406
              dated 02 Aug 2024, NCERT books are being followed in our school.
              This is in strict compliance with the prescribed educational
              guidelines.
            </p>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NotebookStationeryUkg-v.pdf"
                  target="_blank"
                >
                  {" "}
                  Notebook & Stationery List (Ukg-V): 2024-25{" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/NotebookStationeryVI-XII.pdf"
                  target="_blank"
                >
                  {" "}
                  Notebook & Stationery Items (VI-XII) : 2024-25{" "}
                </Link>
              </div>
            </div>
            <h6>Standardisation Of The Air Force School Uniform</h6>
            <div className="col-lg-6">
              <div className="linktab">
                <Link to="/SchoolUniform"> School Uniform </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/RevisedSummerUniform.pdf"
                  target="_blank"
                >
                  {" "}
                  Revised Summer Uniform for Girl students (Class IX &
                  above){" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Winter_Uniform_02_12_2025.pdf"
                  target="_blank"
                >
                  {" "}
                  Winter Uniform{" "}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookList;
